export default __webpack_public_path__ + "static/media/patio.c3b39c82.svg";